module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-all-view"
  }, [_c('pane-header', {
    attrs: {
      "tools": _vm.tools,
      "title": _vm.currentView.data.headerTitle,
      "subtitle": _vm.currentView.data.headerSub,
      "hasBackButton": true,
      "appIconKey": _vm.currentView.data.preset
    }
  }), _vm._v(" "), _c('ui-scrollable-container', [_c('ui-data-list', {
    attrs: {
      "preset": _vm.currentView.data.preset,
      "type": "full",
      "tools": _vm.tools,
      "itemCount": 106
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08395c9b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ShowAllView.vue
// module id = 423
// module chunks = 1